var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 home",attrs:{"fluid":""}},[_c('recent-videos'),_c('characters',{attrs:{"colNum":"6","num":"2"}}),_c('preview-activities')],1)}
var staticRenderFns = []

export { render, staticRenderFns }